/**
 * 后端 nos 把 params / result 都存成 **JSON 文本**（spec §6.1），
 * 响应里给的是字符串而不是嵌套对象，页面各处都要 JSON.parse 一次。
 *
 * 这里统一收口：解析失败（脏数据、被手改过的库、空串）一律返回 null，
 * 调用方按「未运行 / 无数据」渲染，绝不让一条坏数据把整个页面搞崩。
 */
export function parseJsonObject<T extends object>(text: string | null | undefined): T | null {
  const raw = (text ?? '').trim()
  if (!raw) return null
  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    return null
  }
  // 合法 JSON 但不是对象（数字 / 数组 / null）同样按「没有这份数据」处理
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return null
  return parsed as T
}
